<template>
    <div class="container pt-2">
        <PageTitle main="Relatório de Transportes por Status" sub="" />
        <div class="row">
            <div class="col-md-12">
                <b-form-group label="Status:" label-for="status">
                    <b-form-select id="status" :options="statuses"
                        v-model="temp.id"
                        @change="loadStatus()"
                        placeholder="Informe o nome do status."
                        class="textInput"/>
                </b-form-group>
            </div>
        </div>
        <div class="row justify-content-md-center" v-if="isLoading">
            <b-spinner variant="success" label="Spinning"></b-spinner>
        </div>
        <b-button variant="success" block class="mt-2 mb-2 botaoInput" @click="callReport" v-if="!visualizaReport && !isLoading">Gerar Relatório</b-button>
        <hr v-if="!visualizaReport">
        <b-button variant="warning" block class="mt-2 mb-2 botaoInput" :href="link" v-if="visualizaReport">Salvar</b-button>
        <hr v-if="visualizaReport">
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <b-table 
                hover 
                striped 
                id="table-transportes" 
                class="text-center table table-sm" 
                :items="transportes.length>0?transportes:[]" 
                :fields="fields">
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
        </div>
        <div v-else>
            <b-table 
                hover 
                striped 
                id="table-transportes" 
                class="text-center table table-sm" 
                :items="transportes.length>0?transportes:[]" 
                :fields="fields" >
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'

export default {
    name: 'TransportesByStatus',
    components: { PageTitle },
    data: function() {
        return {
            larguraTela: 0,
            overflowValue: 'auto',
            visualizaReport: false,
            isLoading: false,
            link: '',
            status: {},
            statuses: [],
            rep: {},
            temp: {},
            exibeRodape: true,
            transportes: [],
            fields: [
                { key: 'rastreio', label: 'Rastreio', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'data', label: 'Data', sortable: true, formatter: 'formatData', thClass: 'tituloTabela', tdClass: 'fieldsTabela' }
            ]
        }
    },
    methods: {
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        loadTransportes(nome) {
            const url = `${baseApiUrl}/backend/logByStatus.php?titulo=${nome}`
            axios.get(url).then(res => {
                this.transportes = res.data
                if(this.transportes.length > 0) {
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        callReport() {
            this.isLoading = true
            const url = `${baseApiUrl}/backend/repTransportesBystatus.php?status=${this.status.id}&status_titulo=${this.status.titulo}`
            axios.get(url).then((res) => {
                this.isLoading = false
                this.visualizaReport = true
                this.link = res.data['result']
            })
        },
        loadStatuses() {
            const url = `${baseApiUrl}/backend/status.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.statuses = res.data.map(status => {
                        return { ...status, value: status.id, text: status.titulo }
                    })
                }else{
                    this.statuses.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        },
        loadStatus() {
            const url = `${baseApiUrl}/backend/status.php?id=${this.temp.id}`
            axios.get(url).then(res => {
                this.status = res.data[0]
                this.loadTransportes(this.status.titulo)
            })
        }
    },
    mounted() {
        this.loadStatuses()
        this.exibeRodape = true
        this.visualizaReport = false
        this.larguraTela = screen.width - (screen.width * 0.08)
    }
}
</script>

<style>
</style>